// extracted by mini-css-extract-plugin
export var desc = "reg-module--desc--f70b7";
export var inner = "reg-module--inner--20026";
export var reg = "reg-module--reg--1f61c";
export var time = "reg-module--time--30bab";
export var title = "reg-module--title--f9f7b";
export var widget = "reg-module--widget--d18d4";